const athleticsKeys = [
  "football",
  "hockey",
  "soccer",
  "volleyball",
  "baseball",
  "basketball",
  "crossCountry",
  "golf",
  "lacrosse",
  "swimming",
  "tennis",
  "fieldHockey",
  "trackAndField",
  "wrestling",
  "softball",
  "cheer",
  "dance"
];
const artsKeys = ["theatre", "choir", "band", "marchingBand", "orchestra", "visualArts"];
const educationalKeys = [
  "spedSignificantSupportNeeds",
  "careerTechnicalEducation",
  "collegeCareerAdvising",
  "emotionalDisabilityPrograms",
  "englishAsSecondLanguage",
  "communicationSocialDelay",
  "ruler",
  "emotionalInteligence",
  "sourcesOfStrength",
  "pbl",
  "ibPyp",
  "ibMyp",
  "ibDp",
  "ibCp",
  "deca",
  "stem",
  "steam",
  "nsoe",
  "tag",
  "avid",
  "ap",
  "honors",
  "artsAcademy",
  "immersion",
  "emotionalIntelligence",
  "childCare",
  "mtss",
  "highTrails",
  "pltw"
];

let definitions = [
  {
    value: "tag",
    text: "Talented and Gifted (TAG)",
    description: ""
  },
  {
    value: "broadcast",
    text: "Broadcast Video Program",
    description:
      "Student-run program where students learn video production skills while creating broadcast videos each week, as well as occasional creative short films."
  },
  {
    value: "avid",
    text: "Advancement Via Individual Determination (AVID)",
    description:
      "A college readiness program designed to help students develop the skills they need to be successful in college."
  },
  {
    value: "ib",
    text: "International Baccalaureate (IB)",
    description:
      "IB programs challenge students to excel in their studies, and encourage both personal and academic achievement."
  },
  {
    value: "ap",
    text: "Advanced Placement (AP)",
    description:
      "A program that offers college-level curricula and examinations to high school students."
  },
  {
    value: "honors",
    text: "Honors Education",
    description:
      "Characterized by in-class and extracurricular activities that are measurably broader, deeper, or more complex than comparable learning experiences typically found at institutions of higher education."
  },
  {
    value: "pbl",
    text: "Project Based Learning (PBL)",
    description:
      "Project-based learning is a student-centered pedagogy that involves a dynamic classroom approach in which it is believed that students acquire a deeper knowledge through active exploration of real-world challenges and problems."
  },
  {
    value: "artsAcademy",
    text: "Academic Integrated Arts",
    description:
      "The Academic Integrated Arts empowers student's to synthesize academic content with the arts; fostering creativity and expression as they interact with the arts community."
  },
  {
    value: "immersion",
    text: "Language Immersion",
    description:
      "Technique used in bilingual language education in which two languages are used for instruction in a variety of topics, including math, science, or social studies."
  },
  {
    value: "steam",
    text: "Science, Technology, Engineering, Arts, and Math (STEAM)",
    description:
      "Educational approach to learning that uses Science, Technology, Engineering, the Arts and Mathematics as access points for guiding student inquiry, dialogue, and critical thinking."
  },
  {
    value: "stem",
    text: "Science, Technology, Engineering, and Math (STEM)",
    description:
      "Interdisciplinary approach to learning where rigorous academic concepts are coupled with real-world lessons as students apply science, technology, engineering, and mathematics."
  },
  {
    value: "coding",
    text: "Coding and Design Thinking",
    description:
      "Students build on foundational programming skills and use current coding methodologies for computer problem solving to design and construct innovative, real-world technology solutions."
  },
  {
    value: "cyberSecurity",
    text: "Cyber Security",
    description:
      "Take on cybersecurity scenarios as you compete as a team against other teams around the nation"
  },
  {
    value: "technology",
    text: "Gateway to Technology (GTT)",
    description:
      "Gateway to Technology is Project Lead the Way’s introductory program which engages middle school students in activity-based curricula in the areas of science, engineering, technology, and mathematics.",
    url: "https://www.asd20.org/Info/Academics/Pages/Gateway-To-Tech.aspx"
  },
  {
    value: "robotics",
    text: "Rocky Mountain Robotics",
    description:
      "After school program for middle and high school students, who have a passion for creation and development.  Students will learn how to build and engineer robots."
  },
  {
    value: "ruler",
    text:
      "Recognizing, Understanding, Labeling, Expressing, and Regulating (RULER)",
    description:
      "Approach to Social and Emotional Learning is a school-wide approach designed for use in kindergarten through eighth grade to promote emotional intelligence."
  },
  {
    value: "emotionalIntelligence",
    text: "Emotional Intelligence",
    description:
      "Teaching young people skills such as active listening, self-awareness and empathy can equip them to succeed both academically and socially."
  },
  {
    value: "sourcesOfStrength",
    text: "Sources of Strength",
    description:
      "Youth program designed to harness the power of peer social networks to change unhealthy norms and culture, ultimately preventing suicide, bullying, and substance abuse."
  },
  {
    value: "theatre",
    text: "Theatre",
    description:
      "Theatre or theater is a collaborative form of fine art that uses live performers, typically actors or actresses, to present the experience of a real or imagined event before a live audience in a specific place, often a stage."
  },
  {
    value: "choir",
    text: "Choir",
    description:
      "A choir is a musical ensemble of singers. Choral music, in turn, is the music written specifically for such an ensemble to perform. Choirs may perform music from the classical music repertoire, which spans from the Medieval era to the present, or popular music repertoire."
  },
  {
    value: "band",
    text: "Band",
    description: ""
  },
  {
    value: "marchingBand",
    text: "Marching Band",
    description: ""
  },
  {
    value: "orchestra",
    text: "Orchestra",
    description:
      "A large instrumental ensemble typical of classical music, which mixes instruments from different families, including bowed string instruments such as violin, viola, cello, and double bass, as well as brass, woodwinds, and percussion instruments, each grouped in sections."
  },
  {
    value: "drama",
    text: "Drama",
    description:
      ""
  },
  {
    value: "deca",
    text: "Distributive Education Clubs of America (DECA)",
    description:
      "Organization for high school students interested in business, marketing, management, and entrepreneur-ship."
  },
  {
    value: "dance",
    text: "Dance Team",
    description: ""
  },
  {
    value: "football",
    text: "Football",
    description: ""
  },
  {
    value: "hockey",
    text: "Hockey",
    description: ""
  },
  {
    value: "soccer",
    text: "Soccer",
    description: ""
  },
  {
    value: "volleyball",
    text: "Volleyball",
    description: ""
  },
  {
    value: "baseball",
    text: "Baseball",
    description: ""
  },
  {
    value: "basketball",
    text: "Basketball",
    description: ""
  },
  {
    value: "crossCountry",
    text: "Cross Country",
    description: ""
  },
  {
    value: "golf",
    text: "Golf",
    description: ""
  },
  {
    value: "lacrosse",
    text: "Lacrosse",
    description: ""
  },
  {
    value: "swimming",
    text: "Swimming",
    description: ""
  },
  {
    value: "tennis",
    text: "Tennis",
    description: ""
  },
  {
    value: "fieldHockey",
    text: "Field Hockey",
    description: ""
  },
  {
    value: "trackAndField",
    text: "Track and Field",
    description: ""
  },
  {
    value: "wrestling",
    text: "Wrestling",
    description: ""
  },
  {
    value: "softball",
    text: "Softball",
    description: ""
  },
  {
    value: "cheer",
    text: "Cheer",
    description: ""
  },
  {
    value: "spedSignificantSupportNeeds",
    text: "Special Education (SPED): Significant Support Needs Program (SSN)",
    description:
      "Serves students with significant needs who may have cognitive or developmental disabilities, physical or orthopedic disabilities, Traumatic Brain Injury, or multiple disabilities."
  },
  {
    value: "counselling",
    text: "Counseling",
    description: ""
  },
  {
    value: "collegeCareerAdvising",
    text: "College & Career Advising",
    description:
      "Give students the opportunity to explore and learn through practical application of academic and technical skills and knowledge preparing them to compete in a global economy."
  },
  {
    value: "careerTechnicalEducation",
    text: "Career & Technical Education",
    description: ""
  },
  {
    value: "emotionalDisabilityPrograms",
    text: "Special Education (SPED): Affective Needs Program (AN)",
    description:
      "Serves students with emotional disabilities in a highly structured classroom setting with an emphasis on developing self-monitoring and emotional regulation skills."
  },
  {
    value: "englishAsSecondLanguage",
    text: "English as a Second Language (ESL)",
    description:
      "Study of the English language by non-native speakers in an English-speaking environment"
  },
  {
    value: "communicationSocialDelay",
    text: "Special Education (SPED): Communication Social Delay Program (CSD)",
    description:
      "Designed for students with Autism Spectrum Disorder, provides a structured learning environment and intensive support related to the core challenges of Autism.  This includes programming to support development and generalization of skills associated with social interactions, emotional regulation, and communication."
  },
  {
    value: "nsoe",
    text: "Natural Science and Outdoor Education",
    description:
      "Field projects, nature hikes and solo spots. Learning takes place through exploration. This program is for children with exceptional interest in natural science. Students grow into naturalists who learn in, about and from the outdoor world."
  },
  {
    value: "ibPyp",
    text: "International Baccalaureate (IB): Primary Years Programme",
    description:
      "The PYP prepares students to become active, caring, lifelong learners who demonstrate respect for themselves and others and have the capacity to participate in the world around them. It focuses on the development of the whole child."
  },
  {
    value: "ibMyp",
    text: "International Baccalaureate (IB): Middle Years Programme",
    description:
      "A challenging framework that encourages students to make practical connections between their studies and the real world, the MYP is inclusive by design; students of all interests and academic abilities can benefit from their participation."
  },
  {
    value: "ibDp",
    text: "International Baccalaureate (IB): Diploma Programme",
    description:
      "Research suggests many benefits to choosing the DP. The programme aims to develop students who have excellent breadth and depth of knowledge – students who flourish physically, intellectually, emotionally and ethically."
  },
  {
    value: "ibCp",
    text: "International Baccalaureate (IB): Career-related Programme",
    description:
      "The CP is a framework of international education addressing the needs of students engaged in career-related education. It leads to further/higher education apprenticeships or employment."
  },
  {
    value: "childCare",
    text: "Before and After School Child Care",
    description:
      "Each elementary school provides before and after school child care through an outside vendor.  The child care program utilizes space within the school and provides a variety of programs for K-5 students.  Contact your child’s school for specific details."
  },
  {
    value: "mtss",
    text: "Multi-Tiered System of Supports",
    description:
      "​Provides academic and social/emotional/behavior support for all students in our district, based on their needs. The purpose of MTSS is to ensure that all students receive the right supports, in the right area, for the right amount of time.",
  },
  {
    value: "highTrails",
    text: "High Trails",
    description:
      "High Trails is an integral part of the sixth-grade curriculum in Academy School District 20. It is a four-day outdoor-education experience located in Florissant, Colorado.",
  },
  {
    value: "pltw",
    text: "Project Lead the Way (PLTW)",
    description:
      "Foster increased enrollment in engineering and engineering technology by enhancing the benefits to students and their schools",
  },
    {
    value: "visualArts",
    text: "Visual / Fine Arts",
    description:
      "Visual arts includes painting, drawing, sculpture, printmaking, digital arts, photography and videography.",
  }
];

export default {
  educationLevels: [
    { value: 'Preschool', text: 'Preschool' },
    { value: 'Kindergarten', text: 'Kindergarten' },
    { value: 'Elementary', text: 'Elementary School' },
    { value: 'Middle', text: 'Middle School' },
    { value: 'High', text: 'High School' }
  ],
  educationalItems: definitions
    .filter(d => educationalKeys.includes(d.value))
    .sort((a, b) => a.text > b.text ? 1 : b.text > a.text ? -1 : 0),
  athleticsItems: definitions
    .filter(d => athleticsKeys.includes(d.value))
    .sort((a, b) => a.text > b.text ? 1 : b.text > a.text ? -1 : 0),

  artsItems: definitions
    .filter(d => artsKeys.includes(d.value))
    .sort((a, b) => a.text > b.text ? 1 : b.text > a.text ? -1 : 0),
};
